import React from 'react';
import foto2 from '../../assets/foto_2_grid.png';
import './AboutHero.css';

const AboutHero = () => {
  return (
    <section className="about-hero">
      <div className="about-hero-container">
        <div className="about-hero-image-wrapper">
          <img src={foto2} alt="Sobre HAKA" className="about-hero-image" />
          <div className="about-hero-overlay"></div>
          <div className="about-hero-content">
            <div className="about-hero-badge">
              <span className="badge-dot"></span>
              SOBRE NÓS
            </div>
            <h1 className="about-hero-title">
              CONHEÇA MAIS SOBRE A MARCA QUE TE VESTE
            </h1>
            <p className="about-hero-subtitle">
              Venha entender mais sobre nosso propósito e o que cultivamos
            </p>
            <button className="btn btn-about">NOSSO INSTAGRAM</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
